import { FunctionComponent, useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Title from "../../../../../components/Title";
import { MalwareConfiguration } from "../../../@types/rldynamicanalysis";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import RlCloudSandboxGrid from "../RlCloudSandboxGrid";
import { RlCloudSandboxMalwareConfigSchema } from "./schemas";
import {
  formatConfigurations,
  getMalwareConfigTabKey,
  sortConfigurations
} from "./utils";

type RlCloudSandboxMalwareConfigurationsProps = {
  configs: MalwareConfiguration;
};

const RlCloudSandboxMalwareConfigurations: FunctionComponent<
  RlCloudSandboxMalwareConfigurationsProps
> = ({ configs }) => {
  const formattedConfigurations = useMemo(
    () => formatConfigurations(sortConfigurations(configs)),
    [configs]
  );

  const [activeTab, setActiveTab] = useState(
    formattedConfigurations?.length
      ? getMalwareConfigTabKey(formattedConfigurations[0]["title"] ?? 0)
      : undefined
  );
  const handleTabsSelect = (tabsKey: string) => {
    setActiveTab(tabsKey);
  };

  const hasData = !!configs?.configurations?.length;

  useEffect(() => {
    setActiveTab(
      formattedConfigurations?.length
        ? getMalwareConfigTabKey(formattedConfigurations[0]["title"] ?? 0)
        : undefined
    );
  }, [formattedConfigurations]);

  return (
    <div>
      <Title Level="h2" text={`Malware Configurations (All Reports)`} />
      {hasData ? (
        <Tabs
          id="rl-mawlare-configurations"
          variant="tabs"
          activeKey={activeTab}
          className="rlbs"
          transition={false}
          onSelect={handleTabsSelect}
          mountOnEnter
        >
          {formattedConfigurations.map((data, index) => (
            <Tab
              title={data.title}
              eventKey={getMalwareConfigTabKey(data.title)}
              key={getMalwareConfigTabKey(data.title)}
            >
              <div
                className={"mb-20 grid-malware-configuration overflow-auto"}
                data-testid={`rlcs-malware-configuration-config-grid_${index}`}
              >
                <RlCloudSandboxGrid
                  data={Object.entries(data.data || {}).map(
                    ([name, value]) => ({
                      name,
                      value: Array.isArray(value) ? value : [value],
                      title: data.title
                    })
                  )}
                  schema={RlCloudSandboxMalwareConfigSchema}
                  hidePaging
                />
              </div>
            </Tab>
          ))}
        </Tabs>
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.malware_configurations.no_data}</b>
      )}
    </div>
  );
};

export default RlCloudSandboxMalwareConfigurations;
